import React from 'react'

const Error = () => {
  return (
    <div className='flex items-center justify-center text-3xl text-richblack-25 '>
     Error - 404 Not found
    </div>
  )
}

export default Error